var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_1425_1987)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1425_1987",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1425_1987",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1425_1987",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEX0lEQVR4nO2ae4gVZRjGx24mFfVHFBXYHxUGFUaxSJe9uNqVFpXE2ih3vUQUSlIQCoVoLlESZVERFpUKmSIompUF0YomdJXaRFxcsKxVz5x3zjm7e/Zcn/i+1c05c9xdcLd5z5nnBw8cdr45Z+b97cx3mXEcQgghhBBCCCGEEEIIIYQQQggZBHVODe5yGhhn7FPn1AwvpNbpQK0Dxvk/0kEhtapCIYi0kPpzUHzgsrBPGpEVUnjocqTb5iH59SbEDx9EzI0jJgnETsSQ/GojMstmoth4YdhFQNULKd5/KXrXLofb/c+AgJORjp+tICNKwckjEkJyc2+GHNjvE+EeP4706meAqeefcb/s4oawi4GqE5J96k643d0+GfGuTuSenDLsvvLrXhSargy7IKgaIflHr4d7pMt/ZRzrRm7+bUPuZ/oR968jA/vEPfSsexVovCDswqCyhdSNg/f9Lp8Mk/6Vc0d0IH3vLkXMFSTaPw+7IKgKIZllswIyvJ9222FuadviPRcF/tb7wQoUZl+L3o9W2QGBr/20CUD9uWEXqrKEJPZ8ERBibkXlZPS+/1LwO04XVyIx80ITsk/fHXahKkdIoemK/+YXg33HMRTvvdgnwoyyeja+hXjnAfStWYLs4qlDHly+eZJt5+35Eolvt9rPhYcnhl0w/UIyzz8YuDrMFVPaLtdyC+KHD9ntqU1vj6jjTre1Dnb25raooGD6haRfWRgQktr2YaBdsXG8nZ8kd24of9sqk+yz0+Dt+wbyy17kFtwedrEqQ0jfmucCQno+fSPQrjDrGhRmXm0/5xbWjOgAc/NutZNJs7xiJpwKCqZfSP/KJwJCkjvXh31iiKwQ0zmXHfIO9+N1485ue21V5uyFFKdPCCwimk741O1pqL5nyO1t88MuTmUKMUnuWBe4SuxiYpm2+cdutH1D/OBvdoRm+4nTRlz5x28a2N7VaRccc62TgYbzwi5UZQkxQ1qz9FG6qFi875KgkOZJdtRk5yt/H0X/i3P839U62S7T2+1H/4zKcHd0hZikNr8THG1tWF22rRn2xg/9cca+pmf9a3Z7Ynfk1rZGT4iZjXs/tgcXGF9uCbRNr2qxtynz31/uYZV5iGVuU/3Lm30z/ghkdJ+HFGZcBdm/zy/FFfS9uSTsE0VknxiaKyW5/ZPg3GTXZ8g33xD2CSOyLzlkF9XbZQ+fGPNyw/aPkVk6I7DMzjhjK+RU8o9ch/Tri5DautY+gPJ++A6J9h1IbXnv5Fsn48MuAhSFL8pBVygEukIh0BUKQaUJOSHe76VDWCYxJjG1phDREwoRXaEQ0RUKEV2hENEVChFdoRDRFQoRXaEQ0RUKEV2hENEVChFdoRDRFQoRXaEQ0RUKEV2hENEVChFdoRDRFQoRXaEQ0RUKEV2hENEVChFdoRDRFQoRXaEQ0RUKEV2hENEVCpEKFOK6iTtinjed8cY8ptbDCiGEEEIIIYQQQgghhBBCCCGEONHhX1YXq+IOXI/LAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/sg.48568e5ee4e4df2482ab2205836e94f8.svg";
export { ForwardRef as ReactComponent };